// Signed in, but in no business at all (400 business_required from /me or any
// authed call — lib/no-business.ts): drop the stale business/branch and any
// leftover wizard state, then open the onboarding's «create your business»
// step (the business guard there claims pending invites first, exactly like a
// fresh enrollment). Online only — an intranet node has no web onboarding, so
// there the error card stays.

import { useEffect, useRef, useSyncExternalStore, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ONB, onboardingAvailable, onboardingStore } from '@/features/onboarding';
import { sessionStore } from '@/lib/auth';
import { ME_QUERY_KEY } from '@/lib/me';
import { noBusinessStore } from '@/lib/no-business';

export function NoBusinessGate({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const qc = useQueryClient();
  // Only reports made after this mounted count (see lib/no-business.ts).
  const mountedAt = useRef(noBusinessStore.seq());
  const seq = useSyncExternalStore(noBusinessStore.subscribe, noBusinessStore.seq, noBusinessStore.seq);
  const triggered = seq > mountedAt.current && onboardingAvailable();

  useEffect(() => {
    if (!triggered) return;
    mountedAt.current = noBusinessStore.seq();
    sessionStore.setBusinessId(null);
    sessionStore.setBranchId(null);
    onboardingStore.set({ intent: 'owner', createdId: null, erpSynced: false, memberships: null });
    qc.removeQueries({ queryKey: ME_QUERY_KEY });
    navigate(ONB.name, { replace: true });
  }, [triggered, navigate, qc]);

  return <>{children}</>;
}
